import apiV2 from "api-v2";
import { ApiResponse } from "types/common.types";
import { RfxProjectLite } from "../../types/rfx.types";

/**
 * @deprecated Use getProjectsWithSupplierLists instead — supports project_type_id filtering.
 */
export const getProjectSupplier = async (): Promise<RfxProjectLite[] | null> => {
	return getProjectsWithSupplierLists();
};

export const getProjectsWithSupplierLists = async (
	projectTypeId?: number | null
): Promise<RfxProjectLite[] | null> => {
	try {
		const params = projectTypeId
			? `?project_type_id=${projectTypeId}`
			: "";
		const { data: response } = await apiV2.get<ApiResponse<RfxProjectLite[]>>(
			`project/retrieve-project-lite${params}`
		);
		if (response.status) {
			return response.data;
		} else {
			return null;
		}
	} catch (err: any) {
		throw new Error(err?.response?.data?.message);
	}
};
